import React, { useState, useEffect } from 'react';
import useAxios from 'hooks/useAxios';
import {
    Card,
    CardBody,
    CardTitle,
    Col,
    Row,
    CardHeader,
    Button,
    Input,
    Nav,
    NavItem,
    NavLink,
} from 'reactstrap';
import ErrorBoundary from 'components/ErrorBoundary';
import { default as ReactSelect } from "react-select";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    BarElement,
    Title,
    Tooltip,
    Legend,
    ArcElement,

} from 'chart.js';
import { Bar, Chart, } from 'react-chartjs-2';
import CustomeDate from 'pages/ClientDashBoard/Components/Widgets/CustomeDate';
import Drawer from 'components/Drawer';
import SpecialDrugUtilizationDrawer from '../GridData/SpecialityDrugUtilizationDrawer';
import HoverImage from 'react-hover-image/build';
//import QuestionIcon from 'assets/icon/question-mark.svg';
// import PharmacyWidgetDrawer from 'pages/Dashboard/components/GridData/PharmacyWidgetDrawer';
ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    BarElement,
    Title,
    Tooltip,
    Legend,
    ArcElement
);

ChartJS.register(ArcElement, Tooltip, Legend);

const plugin = {
    beforeInit(chart) {
        // Get reference to the original fit function
        const originalFit = chart.legend.fit;

        // Override the fit function
        chart.legend.fit = function fit() {
            // Call original function and bind scope in order to use `this` correctly inside it
            originalFit.bind(chart.legend)();
            // Change the height as suggested in another answers
            this.height = this.height + 25;
        };
    },
};

const TopSpecialtyDrugsUtilization = ({ dateRange, planId, groupId, startDate, endDate, datavalue,rebatechecked }) => {
    const API = useAxios();
    const [active, setActive] = useState('3');
    const [graphData, setGraphData] = useState(null);
    const [options, setOptions] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
     const [graphClaimStatus,setgraphClaimStatus] = useState('NPC');
    const [disabledViewButtom, setDisabledViewButtom] = useState(true);
        const [loading, setLoading] = useState(false);
    
    const [disabledChartFilterButton, setDisabledChartFilterButton] = useState(true);
    useEffect(() => {

        getTopSpecialtyDrugsUtilization(graphClaimStatus);
    }
        , [dateRange, planId, groupId, startDate, endDate, datavalue]);

    const claimStatus = [
        { value: 'ALL', label: 'All' },
        { value: 'NPC', label: 'Net Paid Claims' },
        { value: 'REJ', label: 'Rejected' },
        { value: 'REV', label: 'Reversal' }
    ]

    useEffect(()=>{
    if(planId==-1){
        setgraphClaimStatus("NPC")
    }
    },[planId])

    const getTopSpecialtyDrugsUtilization = async (graphClaimStatus) => {
        setLoading(true);
        const { data } = await API.get(
            `/PBMTenant/${planId}/PBMClientDashboard/getTopSpecialtyDrugsUtilization/${groupId}/${dateRange}/${startDate}/${endDate}/${graphClaimStatus}`);
        if (data) {

             if(Array.isArray(data)){
              datavalue.push(data)
              setLoading(false);
          }
            // datavalue.push(drugUtilization.length>0?drugUtilization:[])
            let grpOptions = {
                maintainAspectRatio: false,
                indexAxis: 'y',
                barThickness: 22,
                elements: {
                    bar: {
                        borderWidth: 2,

                    },
                },
                scales: {
                    x: {
                        grid: {
                            display: true,
                        },
                        ticks: {
                            // include a dollar sign in the ticks
                            callback: function (value, index, values) {
                                if (value > 1000) {
                                    return (
                                        '' + (value / 1000)?.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') + 'k'
                                    );
                                }
                                else {
                                    return (
                                        '' + value?.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
                                    );
                                }

                            }
                        },
                    },
                    y: {
                        grid: {
                            display: false,
                        },
                    },
                },

                responsive: true,
                plugins: {
                    //enabled:true,
                    //position: 'nearest',
                    tooltip: {
                        callbacks: {
                            title: function (item) {
                                const { label } =
                                    datavalue[0][item[0].dataIndex];
                                return `${label}`;
                            },
                            label: function (d, t) {
                                var xLabel = d.dataset.label;
                                var yLabel = '' + d.formattedValue;
                                return xLabel + ': ' + yLabel;
                            },
                        },
                    },
                    legend: {
                        display: true,
                         position: 'bottom',
                            labels: {
                        padding: 15,
                        usePointStyle: true,
                        pointStyle: 'rect',
                        color: '#707070',
                        font: {
                            weight: 'bold',
                        },
                    },
                      align: 'start',
                    },
                    datalabels: {
                        display: false,
                        anchor: 'start',
                        align: 'end',
                        labels: {
                            value: {
                                color: '#2B3346',
                            },
                        },
                        formatter: function (value) {
                            return (
                                '' + value?.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '1,')
                            );
                        },
                    },
                },
            };

            setOptions(grpOptions);

            setOptions(grpOptions);

            let grpData = {
                labels: datavalue[0]?.map((item) => item.label),
                datasets: [
                    {
                        label: 'Claim Count',
                        data: datavalue[0]?.map((item) => item.specialityClaimCount),
                        borderColor: '#B54DA0',
                        backgroundColor: '#B54DA0',

                    },

                ],
            };

            setGraphData(grpData);
             if (datavalue[0]?.length >0) {
                setDisabledViewButtom(false);
                // setDisabledChartFilterButton(false);
            }
            else {
                setDisabledViewButtom(true);
               //  setDisabledChartFilterButton(true);
            }

              if (datavalue[0]?.length >=0) {
               setDisabledChartFilterButton(false);
            }
            else {
               setDisabledChartFilterButton(true);
            }

        }

    }

     const handelStatus = (value) => {
        datavalue= []
        setgraphClaimStatus(value.value)
            getTopSpecialtyDrugsUtilization(value.value);
           // setStatus(value)
    }

    const handleActive = (title) => {
        setActive(title);
    };
    const getDate = () => {
        setActive('custom')
    }
    const handleProceed = () => {
        setIsOpen(!isOpen);
    }
    const onHandleIsOpen = (hasRefresh) => {
        if (isBoolean(hasRefresh) && hasRefresh) {
            onClose(true);
        }
        setIsOpen(!isOpen)
    }
    return (
        <ErrorBoundary>
            <Card className='p-3 h-100'>
                <CardHeader className='border-0 bg-white px-0 pt-0'>
                    <Row className='align-items-center'>
                        <Col>
                            <CardTitle className='f-20 font-weight-500'>
                                Top 10 Specialty Drugs - Utilization
                                <span className='qu_icon' style={{ "paddingLeft": "10px" }} data-title={"The total Plan Paid amount for the net processed, non-reversed claims per month."}>
                                    {/* <img src={QuestionIcon} style={{"width":"20px"}} /> */}
                                </span>
                            </CardTitle>
                        </Col>
                        <Col xs='auto' hidden={true}>
                            <Nav className='widget-tabs'>
                                <NavItem>
                                    <NavLink
                                        className={
                                            active === '3'
                                                ? 'active-tab cursor-pointer f-12'
                                                : 'cursor-pointer f-12'
                                        }
                                        onClick={() => handleActive('3')}
                                    >
                                        3 Mon
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={
                                            active === '6'
                                                ? 'active-tab cursor-pointer f-12'
                                                : 'f-12 cursor-pointer'
                                        }
                                        onClick={() => handleActive('6')}
                                    >
                                        6 Mon
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={
                                            active === '12'
                                                ? 'active-tab cursor-pointer f-12'
                                                : 'cursor-pointer f-12'
                                        }
                                        onClick={() => handleActive('12')}
                                    >
                                        1 Yr
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink className={
                                        active === 'custom'
                                            ? 'active-tab cursor-pointer f-12'
                                            : 'cursor-pointer f-12'
                                    }>
                                        <CustomeDate getDate={getDate} active={active} />
                                    </NavLink>
                                </NavItem>
                            </Nav>
                        </Col>
                    </Row>
                </CardHeader>

                <CardBody className='dashboard-chart-body'>
                    <div className='dashboard-horizontal-combochart-height'>
                        {graphData && (<Bar options={options} data={graphData}
                            plugins={[plugin]}
                        />)}

                    </div>
                  <Row>

                        <Col className='md-3'>
                            {/* <Label>Status</Label> */}
                            <ReactSelect
                                options={claimStatus}
                                onChange={(e) => handelStatus(e)}
                                value={
                                    claimStatus.filter(option =>
                                        option.value === graphClaimStatus)
                                }
                                className='ms-2 mt-4'
                                  isDisabled={disabledChartFilterButton}
                            />
                        </Col>
                        <Col className="md-2">
                            <Button
                                color='primary'
                                className='ms-2'
                                onClick={handleProceed}
                                style={{ float: "right", position: "absolute", bottom: "3px", right: "30px"}}
                                disabled={disabledViewButtom}
                            >
                                View Report
                            </Button>
                        </Col>

                    </Row>
                </CardBody>
            </Card>
             <Drawer
            direction='end'
            title='Top 10 Specialty Drugs - Utilization'
            isOpen={isOpen}
            toggle={handleProceed}
            size="lg"
        >
            <SpecialDrugUtilizationDrawer dateRange={dateRange} planId={planId} groupId={groupId} startDate={startDate} endDate={endDate} onHandleIsOpen={onHandleIsOpen} graphClaimStatus ={graphClaimStatus}  rebatechecked={rebatechecked}/>
        </Drawer> 
        </ErrorBoundary>
    );
};

export default TopSpecialtyDrugsUtilization;
